import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Copy, Download, Check } from "lucide-react";
import { copyPlain } from "@/lib/vaultCrypto";
import { toast } from "sonner";

/** Viser gjenopprettingskode én gang, med kopier/last ned og bekreftelse. */
export const RecoveryCodeCard = ({ code, onConfirmed, confirmLabel = "Jeg har lagret koden et trygt sted", userEmail }) => {
  const [checked, setChecked] = useState(false);
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try { await copyPlain(code); setCopied(true); toast.success("Gjenopprettingskode kopiert"); setTimeout(() => setCopied(false), 1500); } catch { toast.error("Kunne ikke kopiere"); }
  };
  const download = () => {
    const text = `Controlle – gjenopprettingskode for Passord-hvelvet\n\nKonto: ${userEmail || ""}\nDato: ${new Date().toLocaleDateString("nb-NO")}\n\nKode: ${code}\n\nOppbevar denne trygt og adskilt fra hovedpassordet. Koden kan låse opp hvelvet hvis du glemmer hovedpassordet.\nHovedpassordet valgte du selv ved oppsett – det sendes aldri på e-post. Controlle kan IKKE gjenopprette hvelvet for deg.\n`;
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "controlle-gjenopprettingskode.txt";
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 2000);
  };

  return (
    <div className="space-y-4" data-testid="recovery-code-card">
      <div className="rounded-xl border-2 border-dashed border-primary/40 bg-accent/40 p-4 text-center">
        <p className="text-xs uppercase tracking-wider text-muted-foreground mb-2">Gjenopprettingskode</p>
        <p className="font-mono text-lg sm:text-xl font-semibold tracking-[0.12em] break-all select-all" data-testid="recovery-code-value">{code}</p>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Button type="button" variant="outline" onClick={copy} data-testid="recovery-copy-button">{copied ? <Check className="h-4 w-4 mr-2 text-success" /> : <Copy className="h-4 w-4 mr-2" />} Kopier</Button>
        <Button type="button" variant="outline" onClick={download} data-testid="recovery-download-button"><Download className="h-4 w-4 mr-2" /> Last ned .txt</Button>
      </div>
      <label className="flex items-start gap-3 rounded-lg border p-3 text-sm cursor-pointer">
        <Checkbox checked={checked} onCheckedChange={(v) => setChecked(!!v)} className="mt-0.5" data-testid="recovery-confirm-checkbox" />
        <span>{confirmLabel}. Jeg forstår at Controlle ikke kan gjenopprette hvelvet uten hovedpassord eller denne koden.</span>
      </label>
      <Button type="button" className="w-full" disabled={!checked} onClick={onConfirmed} data-testid="recovery-continue-button">Fortsett</Button>
    </div>
  );
};
